<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">
    <!--      开门记录-->
    <el-row style="padding: 20px">
      <el-table
        :data="doorLogs.records"
        :height="tableHeight"
        border
        class="m-auto"
        style="width: 100%;">
        <el-table-column
          align="center"
          label="编号"
          prop="recordId">
        </el-table-column>
        <el-table-column
          align="center"
          label="人员名称"
          prop="creditPersonName">
        </el-table-column>
        <el-table-column
          align="center"
          label="设备名称"
          prop="deviceName"
          width="300">
        </el-table-column>
        <el-table-column
          align="center"
          label="开门时间"
          prop="openDate">
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      :current-page="doorLogs.current" :hide-on-single-page="true"
      :page-size="doorLogs.size"
      :small="true"
      :total="doorLogs.total"
      class="mb-4 mt-3 text-center"
      layout="prev, pager, next"
      style="padding-left: 35px;width: 92%;"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>

<script>
import {getEntranceGuardList} from "@/network/entranceguard";

export default {
  name: "NewDoor",
  props: ['deviceInfo'],
  data() {
    return {
      // 开门记录
      doorLogs: {},
      page: {
        data: {
          max: 10,
          index: 1
        },
      }
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.5
    }
  },
  mounted() {
    this.getData(this.page.data.index, this.page.data.max, this.deviceInfo.apiId)
  },
  methods: {
    getData(index, max, apiId) {
      getEntranceGuardList(index, max, apiId).then(res => {
        if (res.code === 0) {
          this.doorLogs = res.data
        }
      })
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.deviceInfo.apiId)
    }
  }
}
</script>

<style scoped>

</style>
